import RootCertificateRestService from '../rest/RootCertificateRestService'
import { saveAs } from 'file-saver'

class RootCertificateService {
    static async getCertificateDetails() {
        return RootCertificateRestService.getCertificateDetails()
    }

    static async getCertificate() {
        try {
            const cert = await RootCertificateRestService.getCertificate()
            saveAs(cert, 'rootCer.crt')
        } catch (error) {
            return Promise.reject(error)
        }
    }
}

export default RootCertificateService